module.exports = new __parcel__URL__("gold3.565cd697.png").toString();